import { render, staticRenderFns } from "./RemitoRangos.vue?vue&type=template&id=25774fb3"
import script from "./RemitoRangos.vue?vue&type=script&lang=js"
export * from "./RemitoRangos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports